import { render, staticRenderFns } from "./UCode.vue?vue&type=template&id=13729b3b&scoped=true&"
import script from "./UCode.vue?vue&type=script&lang=js&"
export * from "./UCode.vue?vue&type=script&lang=js&"
import style0 from "./UCode.vue?vue&type=style&index=0&id=13729b3b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13729b3b",
  null
  
)

export default component.exports